import React from "react";

import { Navigate, Outlet } from "react-router-dom";
import {  useCookies } from "react-cookie";


const ProtectedLogin = () => {
    
    const [cookies, setCookie] = useCookies(["token","url"]);
 
    const navegateTo = cookies.url ? cookies.url : "/home";

    return  !cookies.token ? <Outlet /> : <Navigate to={navegateTo} />;
};

export default ProtectedLogin;